"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toProductArray = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const groupBy_1 = __importDefault(require("lodash/groupBy"));

const Product_1 = require("./Product");
/**
 * @description Generates array of products from an array of license groups
 * @param {Array<LicenseGroup>} licenseGroupArray - array of license groups
 * @returns {Array<Product>} array of products
 */


function toProductArray(licenseGroupArray) {
  const groupedLicenseGroups = groupBy_1.default(licenseGroupArray, 'product.id');
  const productArray = [];
  Object.entries(groupedLicenseGroups).forEach(([productId, groupedlicenseGroupArr]) => {
    if (productId !== 'undefined') {
      const licenseGroupsForProduct = groupedlicenseGroupArr.map(licenseGroup => ({
        id: licenseGroup.id
      }));
      const product = new Product_1.Product(Object.assign(Object.assign({}, groupedlicenseGroupArr[0].product), {
        licenseGroups: licenseGroupsForProduct
      }));
      productArray.push(product);
    }
  });
  return productArray;
}

exports.toProductArray = toProductArray;